import React, { useEffect, useState } from 'react';
import { Box, FormControl, makeStyles, useMediaQuery } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import {
    InputMui,
    InputType,
    Variant,
    Article,
    Typography,
    ColorHex
} from '../../../../../styles';

interface IPaiementSelectProps {
    paiement: { value: number; min: number; max: number };
    isDisabled: boolean;
    onChange: (value: string, shouldCalculAmortissement: boolean) => void;
}

const useStyles = makeStyles(() => ({
    borneText: {
        fontSize: '12px !important'
    }
}));

export const PaiementInput: React.FC<IPaiementSelectProps> = ({
    paiement,
    isDisabled,
    onChange
}) => {
    const [t] = useTranslation('PaiementSelect');
    const isMobile = useMediaQuery('(max-width:640px)');
    const [isInRange, setIsInRange] = useState(true);
    const [value, setValue] = useState(String(paiement?.value));
    const classes = useStyles();

    const RenderBornes = () => (
        <Typography
            variant={Variant.p}
            article={Article.a5}
            className={classes.borneText}
            color={ColorHex.lightGraphite5}
        >
            {t('minimum')}{' '}
            {t('Number:currency', {
                value: paiement.min
            })}
            {' - '}
            {t('maximum')}{' '}
            {t('Number:currency', {
                value: paiement.max
            })}
        </Typography>
    );

    const getIsInRange = (value) => {
        setIsInRange(true);

        if (isDisabled) {
            return true;
        }
        return Number(value) >= paiement.min && Number(value) <= paiement.max;
    };

    const handleChange = (e) => {
        const value = e.target.value;
        // Save value in real time in state
        setValue(String(value));
        setIsInRange(getIsInRange(value));
    };

    const handleFocusOut = (e) => {
        const value = e.target.value;
        // Calcul if error must be displayed
        setIsInRange(getIsInRange(value));
        // Save value in store and state
        const fixed = Number(value).toFixed(2);
        setValue(String(fixed));
        onChange(String(fixed), false);
    };

    useEffect(() => {
        if (paiement?.value) {
            // If paiement changed -> reset error and value
            setValue(String(Number(paiement?.value).toFixed(2)));
        }
    }, [paiement]);

    return (
        <>
            <FormControl
                style={{
                    width: isMobile ? '100%' : '14.5rem'
                }}
            >
                <InputMui
                    dataTestId={'input_paiement'}
                    isError={!isInRange}
                    helperText={!isInRange && t('erreurPaiementInput')}
                    isDisable={isDisabled}
                    adornment={'$'}
                    key="InputMui_01"
                    value={value}
                    type={InputType.NUMBER}
                    onBlur={handleFocusOut}
                    onFocus={() => setIsInRange(true)}
                    onChange={handleChange}
                />
            </FormControl>

            {/* Lorsque accelere les borne s'affiche pas donc on met on espace vide pour que le bouton bouge pas */}
            {isDisabled && <Box height={'34px'} />}
            <Box>{!isDisabled && <RenderBornes />}</Box>
        </>
    );
};
